/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link, Typography, Typography2, useTheme } from '@coursera/cds-core';

import { COURSERA_REBRAND_LOGO_IMG_SRC } from 'bundles/page/common/constants';

import _t from 'i18n!nls/common';

export const ClipsErrorMessage = () => {
  const theme = useTheme();

  const styles = {
    logo: css`
      height: 80px;
      margin-bottom: var(--cds-spacing-150);
    `,
  };

  return (
    <div data-testid="error-message">
      <img css={styles.logo} src={COURSERA_REBRAND_LOGO_IMG_SRC} alt={_t('My Coursera')} />
      <Typography variant="d2semibold">{_t('404 Error: Access Denied to Clips Page')}</Typography>
      <Typography2 component="p" css={{ marginTop: 'var(--cds-spacing-300)' }}>
        {_t(
          'Learners must be an active member of an enterprise program to access this link. Contact your learning administrator to ask about getting access.'
        )}
      </Typography2>
      <Typography2 component="p" css={{ marginTop: 'var(--cds-spacing-300)' }}>
        {_t('If you have access to an enterprise program and are receiving this error, check you are')}{' '}
        <Link href="/login">{_t('logged in')}</Link> {_t(' and that this link doesn’t have typos.')}
      </Typography2>
      <Typography2 component="p" css={{ marginTop: 'var(--cds-spacing-300)' }}>
        {_t(
          // eslint-disable-next-line no-restricted-syntax
          'If the link is accurate, the video might have been removed from the Coursera library. To find a similar video or course, please use the search feature.'
        )}
      </Typography2>
    </div>
  );
};
